import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/telephoneKeypad/private/TelephoneKeypad.module_built.css";
const classes = {"telephone-keypad__info-message":"wEgqGmW_telephone-keypad__info-message","telephone-keypad":"wEgqGmW_telephone-keypad","telephone-keypad__box":"wEgqGmW_telephone-keypad__box","telephone-keypad__info-message-link":"wEgqGmW_telephone-keypad__info-message-link"}
export default classes

const _telephone_keypad__info_message0 = classes["telephone-keypad__info-message"]
export { _telephone_keypad__info_message0 as "telephone-keypad__info-message" }

const _telephone_keypad0 = classes["telephone-keypad"]
export { _telephone_keypad0 as "telephone-keypad" }

const _telephone_keypad__box0 = classes["telephone-keypad__box"]
export { _telephone_keypad__box0 as "telephone-keypad__box" }

const _telephone_keypad__info_message_link0 = classes["telephone-keypad__info-message-link"]
export { _telephone_keypad__info_message_link0 as "telephone-keypad__info-message-link" }
